import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['stepContent', 'stepItem', 'progressFill']
  static values = {
    currentStep: { type: Number, default: 1 },
    totalSteps: { type: Number, default: 3 }
  }

  connect() {
    // Check URL for step parameter
    const urlParams = new URLSearchParams(window.location.search)
    const stepParam = urlParams.get('step')
    if (stepParam) {
      const step = parseInt(stepParam, 10)
      if (step >= 1 && step <= this.totalStepsValue) {
        this.currentStepValue = step
      }
    }
    this.showStep(this.currentStepValue)
  }

  nextStep() {
    if (this.currentStepValue < this.totalStepsValue) {
      this.currentStepValue++
      this.showStep(this.currentStepValue)
    }
  }

  prevStep() {
    if (this.currentStepValue > 1) {
      this.currentStepValue--
      this.showStep(this.currentStepValue)
    }
  }

  goToStep(event) {
    // Handle keyboard events - only respond to Enter and Space
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
      return
    }
    if (event.type === 'keydown') {
      event.preventDefault()
    }

    const stepNumber = parseInt(event.currentTarget.dataset.step, 10)
    if (stepNumber >= 1 && stepNumber <= this.totalStepsValue) {
      this.currentStepValue = stepNumber
      this.showStep(this.currentStepValue)
    }
  }

  showStep(stepNumber) {
    // Hide all step contents
    this.stepContentTargets.forEach(content => {
      content.classList.remove('active')
    })

    // Show current step content
    const currentContent = this.stepContentTargets.find(
      content => parseInt(content.dataset.step, 10) === stepNumber
    )
    if (currentContent) {
      currentContent.classList.add('active')
    }

    // Update step indicators
    this.stepItemTargets.forEach(item => {
      const step = parseInt(item.dataset.step, 10)
      item.classList.remove('active', 'completed')

      if (step < stepNumber) {
        item.classList.add('completed')
      } else if (step === stepNumber) {
        item.classList.add('active')
      }
    })

    // Update progress bar
    if (this.hasProgressFillTarget) {
      const progressPercentage = ((stepNumber - 1) / (this.totalStepsValue - 1)) * 100
      this.progressFillTarget.style.width = `${progressPercentage}%`
      this.progressFillTarget.setAttribute('aria-valuenow', progressPercentage.toString())
    }

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
